import React, { useState, useEffect } from 'react'
import axios from "axios";
import { APIURL,TZ } from "../../../Global";
 import '../userprofile.css';

 import { useAlert } from 'react-alert';
import { Card, Button, Modal } from 'react-bootstrap'
import { Link, useParams,useLocation, useNavigate } from 'react-router-dom';
import LiabilitiesAll from './LiabilitiesAll';
import Bills from './Bills';


function ClinicsMngmntHome() {
  const alert = useAlert();
  
  
 const [selected,setSelected]=useState("Liabilities")
  const [login_datas, setLogin_datas] = useState(
    JSON.parse(sessionStorage.getItem("logindatas")) || null
  );
  let navigate = useNavigate();


 


 return (<>
<div className='row service-providers-wrapper service-providers-wrapper--clinics' style={{marginTop:"1%",width:"100%",minHeight:"71vh"}}>
  <div className="col-3 service-sidecard-wrapper service-sidecard-wrapper--clinics">
    <div className="service-sidecard service-sidecard--compact">
      <div className="service-sidecard-header">
        <div className="service-sidecard-icon">L</div>
        <div>
          <p className="service-sidecard-title">Liabilities</p>
          <p className="service-sidecard-subtitle">Track dues & paid bills</p>
        </div>
      </div>
      <div className="service-sidecard-menu">
        <button
          className={
            selected === "Liabilities"
              ? "patientRecbutton1 service-sidecard-btn active"
              : "patientRecbutton service-sidecard-btn"
          }
          onClick={() => setSelected("Liabilities")}
        >
          Liabilities
        </button>
        <button
          className={
            selected === "bills"
              ? "patientRecbutton1 service-sidecard-btn active"
              : "patientRecbutton service-sidecard-btn"
          }
          style={{ cursor: login_datas.user_type === "staff" ? "not-allowed" : "pointer" }}
          onClick={() => {
            if (login_datas.user_type !== "staff") {
              setSelected("bills");
            }
          }}
        >
          Paid Bills
        </button>
      </div>
    </div>
  </div>
    <div className="col-9 service-content-card service-content-card--clinics" >
  {selected==="Liabilities"? <div>
  <LiabilitiesAll/>
  </div> 
  :selected==="bills"?
  <div>
    <Bills/>
  </div>
  :selected==="pricing"?""
:""}

     

    </div>
    </div>
  </>

  )}



export default ClinicsMngmntHome
